export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden scroll-section-offset"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20abstract%20background%20with%20warm%20deep%20red%20and%20black%20gradient%20textures%2C%20subtle%20geometric%20patterns%2C%20cinematic%20atmosphere%2C%20dramatic%20lighting%2C%20no%20text%2C%20no%20faces%2C%20luxurious%20dark%20aesthetic%2C%20smooth%20gradient%20with%20soft%20glow%20accents%2C%20professional%20backdrop&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left w-full">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 text-primary-300 text-sm font-medium mb-6">
              <i className="ri-fire-line text-base w-4 h-4 flex items-center justify-center"></i>
              <span>全网热门爆料聚合平台</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
              黑料吃瓜
              <span className="block text-2xl md:text-3xl lg:text-4xl font-medium text-white/80 mt-2">
                多版本入口 · 一站式浏览
              </span>
            </h1>

            <p className="text-white/70 text-base md:text-lg leading-relaxed mb-6 max-w-xl lg:max-w-none">
              覆盖51黑料吃瓜、91黑料吃瓜、17黑料吃瓜等多个数字版专属入口，为用户提供便捷的线路选择与最新爆料内容聚合服务。
              无论您使用哪个版本，都能在这里找到对应的访问方式，轻松追踪每日热点八卦与深度爆料。
            </p>

            <p className="text-white/60 text-sm md:text-base leading-relaxed mb-8">
              当前已收录黑料吃瓜52、黑料吃瓜92、黑料吃瓜18等热门线路，持续更新中。
            </p>

            <div className="flex flex-wrap items-center gap-6 mb-8 justify-center lg:justify-start">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">15+</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">线路版本</div>
              </div>
              <div className="w-px h-10 bg-white/20"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">日更</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">内容更新</div>
              </div>
              <div className="w-px h-10 bg-white/20"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">HTTPS</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">安全访问</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#ranking"
                onClick={(e) => handleScrollTo(e, '#ranking')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-400 text-white font-semibold rounded-full transition-all whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
                查看热度榜单
              </a>
              <a
                href="#cards"
                onClick={(e) => handleScrollTo(e, '#cards')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 text-white font-medium rounded-full border border-white/30 transition-all whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                <i className="ri-article-line w-4 h-4 flex items-center justify-center"></i>
                浏览精选爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden border border-white/10 shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20modern%20digital%20news%20aggregation%20concept%20with%20glowing%20nodes%20and%20connection%20lines%2C%20warm%20amber%20and%20deep%20crimson%20color%20scheme%2C%20dark%20background%2C%20futuristic%20data%20visualization%20style%2C%20dynamic%20flowing%20shapes%2C%20cinematic%20lighting%2C%20no%20text%2C%20no%20faces%2C%20luxurious%20tech%20aesthetic&width=800&height=600&seq=hero-visual-2026&orientation=landscape"
                alt="黑料吃瓜多版本聚合入口"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}